import Vue from 'vue'
import { path } from './helpers'

const client = () => Vue.prototype.$api

export default {
  getCode (code) {
    return client().get(path(`companies/codes/${code}`))
  },
  showGroupDialog (codeGroup) {
    return client().get(path(`companies/group/${codeGroup}`))
  },
  getSpecialties () {
    return client().get(path(`companies/specialties`))
  },
  getSpecialtiesInfo () {
    return client().get(path(`companies/specialties/info`))
  },
  getConsultationTypes (specialty) {
    return client().get(path(`companies/consultation-types`), { params: { specialtyId: specialty } })
  },
  getLanguages (specialty) {
    return client().get(path(`companies/languages`), { params: { specialtyId: specialty } })
  },
  resetCode (code, reservationNumber, startDate, endDate) {
    return client().post(path('companies/code-resets', {
      code,
      reservationNumber,
      startDate,
      endDate
    }))
  }
}



// WEBPACK FOOTER //
// ./src/repositories/CompaniesRepository.js